import React from "react";
import { Band, Glow, Reveal } from "./shared";
import { BRAIN_NERVES_IMG, PAIN_REASONS } from "./content";

export function PainIsRealSection() {
  return (
    <Band id="pain-is-real">
      <Glow className="top-10 left-1/3 w-[520px] h-[520px] bg-[#3B82F6]/8" />
      <Reveal>
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
            <span className="text-white">YOUR PAIN IS </span>
            <span className="text-[#3B82F6]">REAL.</span>
          </h2>
          <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight leading-[1.1] mt-3">
            <span className="text-white">THE CAUSE MAY </span>
            <span className="text-[#3B82F6] underline decoration-[#3B82F6] decoration-4 underline-offset-4">NOT</span>
            <span className="text-white"> BE WHAT YOU THINK.</span>
          </h3>
          <p className="text-base sm:text-lg text-white mt-6 leading-relaxed">
            For years, you've been told it's a structural problem.<br />
            Modern pain science reveals a very different truth.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
        <Reveal delay={0.1}>
          <div className="h-full">
            <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-[#060C1C] shadow-[0_24px_70px_rgba(0,0,0,0.55)] h-full">
              <img src={BRAIN_NERVES_IMG} alt="Brain and nervous system pain signals" className="w-full h-full object-cover min-h-[420px]" data-testid="pain-brain-image" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="space-y-4">
            {PAIN_REASONS.map((r, i) => (
              <div key={r.t} className="bps-card p-5 flex items-start gap-4" data-testid={`pain-reason-${i}`}>
                <span className="shrink-0 w-8 h-8 rounded-lg bg-[#3B82F6]/12 border border-[#3B82F6]/25 flex items-center justify-center mt-0.5">
                  <svg className="w-4 h-4 text-[#3B82F6]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </span>
                <div>
                  <div className="font-display font-bold text-white">{r.t}</div>
                  <div className="text-sm text-[#9AAEC6] mt-1 leading-relaxed">{r.d}</div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </Band>
  );
}
